export enum Roles{
    ADMINISTRATOR = "ADMIN",
    USER = "USER",
    HR = "HR",
    HC = "HC",
    DIREZIONE = "DIR",
    SICUREZZA = "SECURITY",
    STAFF = "STAFF",
    JIRA = "JIRA",
    MANAGER = "MANAGER"
}

/** HC (Human Capital) e HR sono la stessa funzione: entrambi i ruoli abilitano le azioni HR. */
export const HR_ROLES: string[] = [Roles.HR, Roles.HC];

export function hasHrRole(roles: string[] | undefined | null): boolean {
    return (roles || []).some(r => HR_ROLES.includes((r || '').toUpperCase()));
}